import * as i0 from '@angular/core';
import { forwardRef, TemplateRef, Component, ChangeDetectionStrategy, Inject, Input, HostBinding, ContentChildren, NgModule } from '@angular/core';
import { tuiCreateOptions, tuiProvideOptions, EMPTY_QUERY, TuiItemDirective, TuiItemModule } from '@taiga-ui/cdk';
import * as i1 from '@taiga-ui/core';
import { TuiModeDirective, TuiSvgModule } from '@taiga-ui/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

const TUI_BREADCRUMBS_DEFAULT_OPTIONS = {
    icon: `tuiIconChevronRight`,
    size: `m`,
    mode: `onLight`,
};
const TUI_BREADCRUMBS_OPTIONS = tuiCreateOptions(TUI_BREADCRUMBS_DEFAULT_OPTIONS);
function tuiBreadcrumbsOptionsProvider(options) {
    return tuiProvideOptions(TUI_BREADCRUMBS_OPTIONS, options, TUI_BREADCRUMBS_DEFAULT_OPTIONS);
}

class TuiBreadcrumbsComponent extends TuiModeDirective {
    constructor(options) {
        super();
        this.options = options;
        this.size = this.options.size;
        this.items = EMPTY_QUERY;
        this.mode = this.options.mode;
    }
}
TuiBreadcrumbsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiBreadcrumbsComponent, deps: [{ token: TUI_BREADCRUMBS_OPTIONS }], target: i0.ɵɵFactoryTarget.Component });
TuiBreadcrumbsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiBreadcrumbsComponent, selector: "tui-breadcrumbs", inputs: { size: "size" }, host: { properties: { "attr.data-size": "this.size" } }, providers: [
        {
            provide: TuiModeDirective,
            useExisting: forwardRef(() => TuiBreadcrumbsComponent),
        },
    ], queries: [{ propertyName: "items", predicate: TuiItemDirective, read: TemplateRef }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"items.changes | async\"></ng-container>\n<ng-container *ngFor=\"let item of items; let last = last\">\n    <ng-container [ngTemplateOutlet]=\"item\"></ng-container>\n    <tui-svg\n        *ngIf=\"!last\"\n        class=\"t-icon\"\n        [src]=\"options.icon\"\n    ></tui-svg>\n</ng-container>\n", styles: [":host{display:flex;align-items:center;height:2.5rem;white-space:nowrap;font:var(--tui-font-text-s);color:var(--tui-text-01)}:host[data-size=l]{font:var(--tui-font-text-m)}.t-icon{margin:0 .25rem;opacity:.4}\n"], components: [{ type: i1.TuiSvgComponent, selector: "tui-svg", inputs: ["src"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i2.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiBreadcrumbsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-breadcrumbs',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    templateUrl: './breadcrumbs.template.html',
                    styleUrls: ['./breadcrumbs.style.less'],
                    providers: [
                        {
                            provide: TuiModeDirective,
                            useExisting: forwardRef(() => TuiBreadcrumbsComponent),
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TUI_BREADCRUMBS_OPTIONS]
                }] }]; }, propDecorators: { size: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.data-size']
            }], items: [{
                type: ContentChildren,
                args: [TuiItemDirective, { read: TemplateRef }]
            }] } });

class TuiBreadcrumbsModule {
}
TuiBreadcrumbsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiBreadcrumbsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiBreadcrumbsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiBreadcrumbsModule, declarations: [TuiBreadcrumbsComponent], imports: [CommonModule, TuiSvgModule, TuiItemModule], exports: [TuiBreadcrumbsComponent, TuiItemDirective] });
TuiBreadcrumbsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiBreadcrumbsModule, imports: [[CommonModule, TuiSvgModule, TuiItemModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiBreadcrumbsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TuiSvgModule, TuiItemModule],
                    declarations: [TuiBreadcrumbsComponent],
                    exports: [TuiBreadcrumbsComponent, TuiItemDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_BREADCRUMBS_DEFAULT_OPTIONS, TUI_BREADCRUMBS_OPTIONS, TuiBreadcrumbsComponent, TuiBreadcrumbsModule, tuiBreadcrumbsOptionsProvider };
